import { ComponentType, FC, MouseEvent, PropsWithChildren } from "react";
import styled from "styled-components";

import Text from "./Text";

const StyledTag = styled(Text)`
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  height: 24px;
  white-space: nowrap;
  border-radius: 50px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  background-color: ${({ theme }) => theme.colors.white};
`;

const CloseBtn = styled.button`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.lightGray};
  transition: 0.2s ease-out color;
  &:hover {
    color: ${({ theme }) => theme.colors.error};
  }
`;

export const TagsHolder = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

interface Props {
  onDelete?: (e: MouseEvent<HTMLButtonElement>) => void;
  as?: ComponentType<any>;
  className?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
}

const Tag: FC<PropsWithChildren<Props>> = ({
  onDelete,
  children,
  className,
  as = "span",
  onClick,
}) => {
  return (
    <StyledTag $type="small" as={as} className={className} onClick={onClick}>
      {children}
      {!!onDelete && (
        <CloseBtn onClick={onDelete} type="button">
          <svg
            width="8"
            height="9"
            viewBox="0 0 8 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.70784 2.20662C8.09836 1.81609 8.09836 1.18293 7.70784 0.792405C7.31732 0.401881 6.68415 0.401881 6.29363 0.792405L4.00037 3.08566L1.70711 0.792405C1.31658 0.401881 0.683417 0.401881 0.292893 0.792405C-0.0976311 1.18293 -0.0976311 1.81609 0.292893 2.20662L2.58615 4.49988L0.292893 6.79314C-0.0976311 7.18366 -0.0976311 7.81683 0.292893 8.20735C0.683417 8.59788 1.31658 8.59788 1.70711 8.20735L4.00037 5.91409L6.29363 8.20735C6.68415 8.59788 7.31732 8.59788 7.70784 8.20735C8.09836 7.81683 8.09836 7.18366 7.70784 6.79314L5.41458 4.49988L7.70784 2.20662Z"
              fill="currentColor"
            />
          </svg>
        </CloseBtn>
      )}
    </StyledTag>
  );
};

export default Tag;
